module.exports = __webpack_public_path__ + "static/media/home-2026-ita.05d47570.jpg";